import { useDispatch, useSelector } from 'react-redux';
import PendingCard from '../PendingsCard';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';
import PendingContactContainer from './PendingContactContaner';
import useFetchDashboard from '../../customHooks/useFetchDashboard';
import { getPendingContacts } from '@/store/slices/components/dashboard/service';
import PendingContactEmptyState from './PendingContactEmptyState';
import { useTrackPendingTab } from '../../customHooks/useTrackDashboard';

function PendingContact() {
  const dispatch = useDispatch();
  const tokkoHost = localStorage.getItem('tokkoBrokerHost');
  const { count, loading, hasFetched, contacts, empty } = useSelector(
    (state) => state.DashboardSlice.pendingContacts
  );
  const track = useTrackPendingTab();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { ref, isStale, useFetchOnViewport } = useFetchDashboard();

  useFetchOnViewport(
    (query) => {
      dispatch(getPendingContacts(query));
    },
    [],
    { hasFetched }
  );

  let urlRedirect = `${tokkoHost}/leads/`;
  const type = selectedIds[0]?.filter_type;
  if (selectedIds.length > 0) {
    urlRedirect += `?${type}=[${selectedIds}]`;
  }
  if (!selectedIds.length) {
    urlRedirect += '?company_leads=true';
  }

  const contactPendingText = `${count} ${Trans(
    translations,
    count === 1 ? 'ContactToReachOut' : 'ContactsToReachOut'
  )}`;

  return (
    <PendingCard ref={ref} loading={loading || isStale}>
      <PendingCard.Header
        redirectUrl={empty ? null : urlRedirect}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={(element) => track.pendingContact(element)}
      >
        {contactPendingText}
      </PendingCard.Header>
      {empty ? (
        <PendingContactEmptyState />
      ) : (
        <PendingContactContainer
          pendingContacts={contacts}
          trackCallback={(element) => track.pendingContact(element)}
        />
      )}
    </PendingCard>
  );
}

export default PendingContact;
